import React from 'react';
import { Link } from 'react-router-dom';
import './GameCard.css';

function GameCard({ title, description, imageUrl, link, infoLink, loading = "lazy", priority = false }) {
  const handleClick = () => {
    // Track game card click event in Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'game_card_click', {
        'game_name': title,
        'event_category': 'engagement',
        'event_label': title
      });
    }
  };

  return (
    <article className="game-card">
      <Link to={link} onClick={handleClick} className="game-card__main">
        <img
          className="game-card__icon"
          src={imageUrl.replace('/icons/Icon-512.png', '/icons/Icon-192.png')}
          alt={`${title} - Logic puzzle game logo`}
          loading={loading}
          fetchpriority={priority ? "high" : "auto"}
          width="72"
          height="72"
          decoding="async"
        />
        <div className="game-card__body">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </Link>
      <div className="game-card__actions">
        <Link to={link} onClick={handleClick} className="game-card__play">
          Play free
        </Link>
        {infoLink && (
          <Link to={infoLink} className="game-card__info" aria-label={`How to play ${title}`}>
            How to play
          </Link>
        )}
      </div>
    </article>
  );
}

export default GameCard;
